import { render, staticRenderFns } from "./Comprobante.vue?vue&type=template&id=81802e48"
import script from "./Comprobante.vue?vue&type=script&lang=js"
export * from "./Comprobante.vue?vue&type=script&lang=js"
import style0 from "./Comprobante.vue?vue&type=style&index=0&id=81802e48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports